import React from 'react';

import ActionButton from '~components/atoms/ActionButton';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';

import * as Styles from './_productManagementDiscounts.module.scss';
import DiscountTable from './DiscountTable';
import DiscountPaginator from './DiscountPaginator';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import DiscountDetailsModal from './DiscountsDetailsModal';
import DiscountCreateModal from './DiscountCreateModal';
import combinedActions from '~redux/combinedActions';
import DiscountDeleteModal from './DiscountDeleteModal';
import DiscountSearchAndFilterBar from './DiscountSearchAndFilter';

const Discount = () => {
    const dispatch = useAppDispatch();

    const createAccessModules = useAppSelector(state => state.auth.userDetails.access).find(access => access.permission === PermissionsEnum.Create)?.modules || [];

    const handleCreateNewDiscountClick = () => {
        dispatch(combinedActions.settingSetProductManagementDiscountCreateModalIsOpen(true));
    };

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Discount List'
                    className={Styles.title}
                    isBold
                />

                {createAccessModules.find(module => module === ModuleEnum.Discount)
                        && <ActionButton
                            label='+ Create New Discount'
                            onClick={handleCreateNewDiscountClick}
                        />
                }
            </TabPageHeaderWrapper>

            <DiscountSearchAndFilterBar/>

            <DiscountTable />

            <DiscountPaginator />

            <DiscountDetailsModal />

            <DiscountCreateModal />

            <DiscountDeleteModal />

        </TabPageContainer>
    );
};

export default Discount;
